const api_base = process.env.VUE_APP_API;
const token = process.env.VUE_APP_TOKEN;

const cache = {};

export default class Api {
  static get = (endpoint, params) => {

    params = Object.keys(params).map((key) => {
      return `${key}=${params[key]}&`;
    });

    params = params.join("");

    const url = `${api_base}/${endpoint}?${params}`;

    if (cache[url]) {
      return Promise.resolve(cache[url]);
    }

    return new Promise((resolve, reject) => {
      
      fetch(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${token}`,
        },
      })
        .then(data => data.json())
        .then(data => {
          cache[url] = data;
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  };
}
